<template>
  <div class="shipment-tag-wrapper shipment-tag-loggi">
    <div class="shipment-tag-header">
      <div class="shipment-tag-header-left">
        <img
          class="in-center"
          :src="shippingCompanyIcon"
          :alt="`ícone da transportadora Loggi ${nameService}`"
        />

        <span class="service">
          {{ nameService }}
        </span>
      </div>
      <div class="shipment-tag-header-center">
        <canvas class="melhor-ponto-code in-center"></canvas>
      </div>
      <div class="shipment-tag-header-right">
        <img :src="$parent.tag.companyIcon" class="in-center" alt="ícone da melhor envio">
        <span class="website">{{ $parent.tag.website }}</span>
        <span class="text-inf-right">Peso (g): {{ kilogramsToGrams($parent.tag.package.weight) }}</span>
      </div>
    </div>

    <div class="shipment-tag-info">
      <div class="field left">
        <span v-if="$parent.tag.invoice.number" style="text-align: left; font-size: 8pt;">NF: {{ $parent.tag.invoice.number }}</span>
        <span v-show="$parent.tag.tracking && $parent.tag.protocol" style="font-size: 8pt; text-align: initial;">{{ $parent.tag.protocol }}</span>
      </div>
    </div>

  <div class="body-loggi">
    <p class="text-subtitle font-normal text-center">{{ tagTracking }}</p>

    <canvas
      class="barcode"
      :data-value="tagTracking || 'LGI-0000000000000'"
      data-height="70"
      data-margin="0"
      data-displayvalue="false"
    ></canvas>

    <div class="shipment-tag-client shipment-tag-to text-small">
      <h2 class="text-left">DESTINATÁRIO</h2>
      <p class="line">
        {{ $parent.tag.to.name }}<template v-if="$parent.tag.to.phone.length">, TEL: {{ maskPhone($parent.tag.to.phone) }}</template>
      </p>
      <p class="line">
        {{ $parent.tag.to.address }}<template v-if="$parent.tag.to.locationNumber.length">, </template>
        {{ $parent.tag.to.locationNumber }}
      </p>
      <p class="line">
        {{ $parent.tag.to.complement }}<template v-if="$parent.tag.to.complement.length">, </template>
        {{ $parent.tag.to.district }}
      </p>
      <p class="line">
        <strong>{{ beautifyPostalCode($parent.tag.to.postalCode) }}</strong> {{ $parent.tag.to.city }}<template v-if="$parent.tag.to.stateAbbr.length">/</template>{{ $parent.tag.to.stateAbbr }}
      </p>
      <p v-if="$parent.tag.to.note.length" class="line">
        OBS: {{ $parent.tag.to.note }}
      </p>
      <div class="shipment-tag-optionals">
        <span v-show="$parent.tag.receipt">AR</span>
      </div>
    </div>

    <div class="shipment-tag-client text-small">
      <h2 class="text-left">REMETENTE</h2>
      <p class="line">
        {{ $parent.tag.from.name }}<template v-if="$parent.tag.from.phone.length">, TEL: {{ maskPhone($parent.tag.from.phone) }}</template>
      </p>
      <p class="line">
        {{ $parent.tag.from.address }}<template v-if="$parent.tag.from.locationNumber.length">, </template>
        {{ $parent.tag.from.locationNumber }}
      </p>
      <p class="line">
        {{ $parent.tag.from.complement }}<template v-if="$parent.tag.from.complement.length">, </template>
        {{ $parent.tag.from.district }}
      </p>
      <p class="line">
        <strong>{{ beautifyPostalCode($parent.tag.from.postalCode) }}</strong> {{ $parent.tag.from.city }}<template v-if="$parent.tag.from.stateAbbr.length">/</template>{{ $parent.tag.from.stateAbbr }}
      </p>
    </div>
   </div>
  </div>
</template>

<script>
  import { kilogramsToGrams, maskPhone } from 'commons/js/formatters/Mask';
  import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
  import MelhorPontoQrCode from 'commons/js/mixins/melhorPontoQrCode';

  export default {
    mixins: [MelhorPontoQrCode],

    data() {
      return {
        shippingCompanyIcon: '',
      }
    },

    computed: {
      tagTracking() {
        return String(this.$parent.tag.tracking).replace('LGI-', '');
      },

      nameService() {
        return this.$parent.tag.serviceName === 'Loggi Ponto' ? 'Ponto' : this.$parent.tag.serviceName;
      }
    },

    mounted() {
      BarCode('.barcode').init();
      this.shippingCompanyIcon = '/images/shipment/loggi/loggi-negativo.png';
    },

    methods: {
      kilogramsToGrams,
      maskPhone,
      beautifyPostalCode
    }
  }
</script>

<style lang="stylus" scoped>
.shipment-tag-loggi
  display flex
  flex-direction column
  .text-left
    text-align left
  strong
    font-weight bold
  .text-small
    font-size 11px
    *
      font-size 11px
    p
      &.line
        margin 2px 0
  .shipment-tag-header
    padding 5px 5px 1px
    height 110px
    .in-center
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
    img
      width 84%
    .service
      position absolute
      bottom 24px
      left 38%
      font-size 9pt
    .shipment-tag-header-left
    .shipment-tag-header-center
    .shipment-tag-header-right
      position relative
      width 33.33%
      height 100%
      display inline-block
    .shipment-tag-header-left
      float left
    .shipment-tag-header-center
      margin 0 auto
    .shipment-tag-header-right
      float right
    .website
      position absolute
      top 85px
      left 19px
      font-weight bold
      font-size 6.9pt
    .text-inf-left
      position absolute
      top 102px
      left 5px
      font-weight bold
      font-size 8pt
    .text-inf-right
      position absolute
      top 95px
      left 19px
      font-weight bold
      font-size 8pt
  .barcode
    max-width 90%
    height 70px
    margin-bottom 10px
  .special-infos
    padding 0 5px
  .shipment-tag-info
    .field
      text-align center
      margin-top -15px
      font-weight bold
      line-height 1
      &.left
        float left
        margin-left 10px
      &.right
        float right
        margin-right 6px
      span
        height 12px
        display block
  .tracking-subtitle
    display flex
    justify-content center
    font-weight bold
    margin-top 40px
  .tracking-nf
    margin-top 30px
  .shipment-tag-client
    margin 5px
    padding 0 5px
    position relative
    h2
      margin 3px 0
      font-weight bold
    p
      margin 0
      white-space nowrap
      text-transform uppercase
    &.shipment-tag-to
      border 1px solid #9c9c9c
      border-radius 3px
      .line
        padding 0
  .body-loggi
    padding 1px 0
  .shipment-tag-optionals
    position absolute
    top 5px
    right 5px
    font-weight bold
    line-height 1.1
    span
      width 45px
      text-align center
      font-size 16pt
      border 1px solid #000
      padding 5px
      margin-bottom 5px
      display block

@media print
  .shipment-tag-loggi
    .shipment-tag-header
      height 110px !important

      img
        width 85%
</style>
